import Api  from './request'

export default class SystemApi {
    static chgPass(form) {
        return Api.post('/api/chg-my-password', form)
    }
}
